module.exports = __webpack_public_path__ + "img/sample-official.7c4b905e.png";